module.exports = "/_next/static/images/video_id_7177231989257325870-e7e23dc187583f4a83677f16801574da.jpg";